import { lazy } from "react";

import { IS_ME_LINK } from "@/constants/app";

export const TestPageLazy = lazy(() => import("@/pages/testPage"));
export const ArchivePageLazy = lazy(() => import("@/pages/archivePage"));
export const ImportCsvPageLazy = lazy(() => import("@/pages/ImportCsvPage"));
export const BulkUrlShortenerPageLazy = lazy(
  () => import("@/pages/BulkUrlShortenerPage")
);
export const DomainPageLazy = lazy(() => import("@/pages/domainPage"));
export const FaqPageLazy = lazy(() => import("@/pages/faqPage"));
export const IntegrationPageLazy = lazy(
  () => import("@/pages/integrationPage")
);
export const ProfilePageLazy = lazy(() => import("@/pages/profilePage"));
export const EntryPageLazy = lazy(() =>
  IS_ME_LINK
    ? import("@/pages/entryPage/indexLink")
    : import("@/pages/entryPage")
);
export const ReferrerPageLazy = lazy(() => import("@/pages/referrerPage"));
export const StatisticsPageLazy = lazy(() => import("@/pages/statisticsPage"));
export const SubscriptionPageLazy = lazy(
  () => import("@/pages/subscriptionPage")
);
export const SupportPageLazy = lazy(() => import("@/pages/supportPage"));
export const ChangeOwnerPageLazy = lazy(() => import("@/pages/changeOwner"));
export const SettingsPageLazy = lazy(() => import("@/pages/settingsPage"));
export const ShareFolderAccessLazy = lazy(
  () => import("@/pages/shareFolderAccess")
);
